<template>
  <div class="viw-logo inline-flex items-center gap-1">
    <!-- Veil into Worlds SVG Logo -->
    <img 
      :src="logoSvg" 
      alt="Veil into Worlds"
      class="logo-svg"
      :style="logoStyle"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import logoSvg from '@/assets/Veil-into-Worlds.svg'

interface Props {
  size?: 'sm' | 'md' | 'lg' | 'xl'
}

const props = withDefaults(defineProps<Props>(), {
  size: 'md'
})

const logoStyle = computed(() => {
  const sizes = {
    sm: '32px',
    md: '48px',
    lg: '72px',
    xl: '96px'
  }
  return {
    width: sizes[props.size],
    height: sizes[props.size]
  }
})

const sizeClass = computed(() => {
  switch (props.size) {
    case 'sm':
      return 'text-sm'
    case 'lg':
      return 'text-2xl'
    case 'xl':
      return 'text-3xl'
    default:
      return 'text-base'
  }
})
</script>

<style scoped>
.viw-logo {
  user-select: none;
}

.logo-svg {
  object-fit: contain;
  filter: drop-shadow(0 0 8px rgba(212, 175, 55, 0.6));
  transition: filter 200ms ease;
}

/* Light mode adjustments */
@media (prefers-color-scheme: light) {
  .logo-svg {
    filter: drop-shadow(0 1px 2px rgba(180, 150, 80, 0.4));
  }
}

:global(.light) .logo-svg {
  filter: drop-shadow(0 1px 2px rgba(180, 150, 80, 0.4));
}

/* Animation on hover */
.viw-logo:hover .logo-svg {
  filter: drop-shadow(0 0 12px rgba(212, 175, 55, 0.8));
}
</style>
